module.exports = __webpack_public_path__ + "img/b1.413c71fc.png";